import env from '../env';

const isAbsoluteMediaUrl = (url: string) =>
  url.startsWith('http://') ||
  url.startsWith('https://') ||
  url.startsWith('blob:') ||
  url.startsWith('data:');

/** Vite/dev filesystem URLs or Windows paths that must never be used as media src. */
export const isInvalidMediaUrl = (url: string) => {
  const value = url.trim();
  if (!value) {
    return true;
  }
  return (
    value.includes('/@fs/') ||
    value.includes('/@fs%2F') ||
    value.startsWith('file:') ||
    /^[A-Za-z]:[\\/]/.test(value) ||
    /katon-play-web[/\\]packages[/\\]theme/i.test(value) ||
    /\/Users\/[^/]+\/Documents\/Projects\//i.test(value)
  );
};

/**
 * Resolves API media values (full URL or S3 key) for <img>/CSS background use.
 * Returns fallback for empty or invalid local Vite paths.
 */
export const resolveMediaUrl = (url?: string | null, fallback = ''): string => {
  const value = (url || '').trim();
  if (!value || isInvalidMediaUrl(value)) {
    return fallback;
  }
  if (isAbsoluteMediaUrl(value) || value.startsWith('/')) {
    return value;
  }
  const base = env.APP_BASE_URL || '';
  if (!base) {
    return value;
  }
  return `${base.replace(/\/?$/, '/')}${value.replace(/^\//, '')}`;
};
